module.exports = __webpack_public_path__ + "static/black-tar-city.9dde446f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/black-tar-city.png
// module id = 458
// module chunks = 202660965941462